
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  ElementStudioExpectedDataToLoad,
  ElementStudioSaveLocation,
  SaveLocationType
} from "@/types/element-studio";
import { isValidItemName } from "@/lib/elements/studio/misc";
import { isBreakdanceDevelopmentEnvironment } from "@/lib/dev/development-environment";
import { configStore } from "@/store/store-accessor";
import Icon from "@/components/UI/Icon.vue";
@Component({
  components: { Icon }
})
export default class ElementStudioSaveNewDialog extends Vue {
  @Prop()
  saveLocations!: ElementStudioExpectedDataToLoad["saveLocations"];

  @Prop()
  itemType!: SaveLocationType;

  newItemDialog = false;
  newItemName = "";
  newItemSaveLocation: ElementStudioSaveLocation | false = false;

  nameIsValid(newName: string) {
    return isValidItemName(newName);
  }

  get showAdvancedFeatures() {
    return (
      isBreakdanceDevelopmentEnvironment() ||
      configStore.isElementStudioPowerUser
    );
  }

  showSaveLocation(saveLocation: ElementStudioSaveLocation) {
    if (saveLocation.type !== this.itemType) return false;

    if (!saveLocation.onlyForAdvancedUsers) return true;

    return this.showAdvancedFeatures;
  }

  saveNewItem() {
    this.$emit("input", {
      ...this.newItemSaveLocation,
      name: this.newItemName
    });

    this.closeNewItemDialog();
  }

  closeNewItemDialog() {
    this.newItemDialog = false;
    this.newItemName = "";
    this.newItemSaveLocation = false;

    this.$emit("close");
  }
}
